<template>
  <Table
    border
    :columns="tableTitle"
    :data="tableDetails"
    stripe
    height="600"
    :loading="tableDetails.length<1"
  ></Table>
</template>

<script>
export default {
  props: {
    tableDetails: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("order_number"),
        key: "airway_number",
        align: "center",
        minWidth: 130,
      });
      columns.push({
        title: this.$t("skuLength"),
        key: "length",
        align: "center",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("skuWidth"),
        key: "width",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("skuHeight"),
        key: "height",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("charge_volume"),
        key: "charge_volume",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("claim_weight"),
        key: "claim_weight",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("check_weight"),
        key: "check_weight",
        align: "center",
        minWidth: 100,
      });
      // columns.push({
      //   title: this.$t("createTime"),
      //   key: "orders_create_time",
      //   align: "center",
      //   minWidth: 170,
      // });
      columns.push({
        title: this.$t("bagTime"),
        key: "create_time",
        align: "center",
        minWidth: 170,
      });
      return columns;
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style>
.delBtn {
  margin: 0 10px;
}
</style>
